<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<div class="form-row">
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instance.prsStore" class="form-control" multiple>
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.active')}}
												</label>
												<select v-model="instance.active" class="form-control">
													<option :value="true">Oui</option>
													<option :value="false">Non</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.accountTot')} ) }}</label>
												<input type="number" step="any" v-model="instance.accountTotInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.accountTot')})}}</label>
												<input type="number" step="any" v-model="instance.accountTotEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.accountTot')})}}</label>
												<input type="number" step="any" v-model="instance.accountTotSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										
									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>

										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	export default {
		name: 'mvtFinancialStatementList',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtfinancialstatement.label'),
				pageTitle: this.$t('mvtfinancialstatement.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'mvtfinancialstatement',
					routerShow: 'mvtfinancialstatementshow',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '7%', 
						actAdd: true, 
						actGet: true, 
						actEdit: false, 
						actDel: false, 
						actPrint: 'produce'
					},
					attrsList: [
						{attrName: 'prsStoreLib', attrCol: '12%', searchable: true, sortable: true},
						{attrName: 'dateStart', attrCol: '13%', searchable: false, sortable: true},
						{attrName: 'dateEnd', attrCol: '13%', searchable: false, sortable: true},
						{attrName: 'amountDebit', attrCol: '12%', searchable: false, sortable: true},
						{attrName: 'amountCredit', attrCol: '12%', searchable: false, sortable: true},
						{attrName: 'accountTot', attrCol: '12%', searchable: false, sortable: true},
						{attrName: 'activeLib', attrCol: '6%', searchable: false, sortable: true},
					]
				},
				instance: {
					prsStore: [],
					accountTot: '',
					active: '',
					
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				prsStoreList: [],
				amountLetter: {},
				chartOptions: {
					title: 'Statistique des arrêtés par ',
					hAxis: {title: 'Désignation'},
					vAxis: {title: 'Solde'},
					recap: {title: 'Solde total', val:0}
				},
				chartData: [],
				typeStats: [
					{id: 'prsStore', label: this.$t('prsstore.label')},
					{id: 'libShort', label: 'Arrêté'}
				],
				typeStat: 'prsStore'
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					this.instance.prsStore = []
					if(!this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.$store.getters.prsInfo.prsStore)
						this.instance.prsStore.push(this.$store.getters.prsInfo.prsStore)
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				this.search();
			}
			// this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					// prsStore: [],
					accountTot: '',
					active: '',
					
					dateEntryAfter:'',
					dateEntryBefore:''
				};

				if(this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					this.instance.prsStore = []
					// this.instance.username = []
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";

				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				// Date super
				strParamsForms = strParamsForms+"&params1=dateStart&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"

				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=dateStart&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}

				strParamsForms = strParamsForms+"&params4=prsStore.id&valParams4="+this.instance.prsStore +"&logParams4=eqL"
				if(this.instance.prsStore && this.instance.prsStore.length >0 ){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsStoreList, this.instance.prsStore, 'storeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsStore')+'(s) : </i><b>'+strLibs + '</b>'
				}
			
				// Amout super
				strParamsForms = strParamsForms+"&params6=accountTot&valParams6="+this.instance.accountTotSup+"&logParams6=geDo"
				if(this.instance.accountTotSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.accountTot')+' > </i><b> '+this.$store.getters.formatAmount(this.instance.accountTotSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=accountTot&valParams7="+this.instance.accountTotEq+"&logParams7=eqDo"
				if(this.instance.accountTotEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.accountTot')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.accountTotEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=accountTot&valParams8="+this.instance.accountTotInf+"&logParams8=leDo"
				if(this.instance.accountTotInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.accountTot')+'< </i><b> '+this.$store.getters.formatAmount(this.instance.accountTotInf) + '</b>'
				}

				strParamsForms = strParamsForms+"&params10=active&valParams10="+this.instance.active+"&logParams10=eqB"
				
				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = [this.$t('prsstore.label'), "Montant par Store"] 
				let attrKey = 'prsStoreLib'
				let attrValue = 'accountTot'
				
				if(this.typeStat === 'prsStore' ){
					attrKey = 'prsStoreLib'
				}
				else if(this.typeStat === 'libShort' ){
					statLabel = ["Jour", "Montant par arrêté"]
					attrKey = 'libShort'
				}
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				let sumData = 0;
				dataList?.forEach(data => {
					this.chartData.push(data);
					sumData = sumData + data[1]
				});
				this.chartOptions.recap.val = this.$store.getters.formatAmount(sumData)
				if(this.chartOptions.recap.title && this.chartOptions.recap.val){
					let detailsBot = '&detailsBot=<i> '+ this.chartOptions.recap.title +' : <b> '+ this.chartOptions.recap.val +'</b> </i>';
					this.$refs.componentDatatableInstance.addStrParamsForms(detailsBot);
				}
			},
			async axiosPost() {
				try {
					await this.$store.dispatch('axiosPost', {
						domain: 'mvtmovement',
						data: this.instanceModal //data
					})
					.then(res => {
						this.instanceModal = res.data;
						// console.log('res.data ', res.data)
						this.modalToggle(this.modalType)
						this.$nextTick(() => {
							let msg = this.$t("mvtmovement.label") + " "+res.data.id;
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('toast.created.message', { obj: msg})
							});
						});
					})
					.catch(error => {
						console.log('Error', error.response)
					})
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
		}
		
	}

</script>